import Block from './Block';
import gsap from 'gsap';

export default class List extends Block {
  onEnterCompleted() {
    super.onEnterCompleted()
    this.init()
  }

  getElems() {
    super.getElems()

    this.$listItems = this.el.querySelectorAll('.b-list__item')
    this.$imgItems = this.el.querySelectorAll('.b-list__img')
    this.listArray = [];

    for (let i = 0; i < this.$listItems.length; i++) {
      this.listArray.push(
        {
          item: this.$listItems[i],
          img: this.$imgItems[i]
        }
      )
    }
  }

  init() {
    this.zIndex = this.listArray.length
    this.oldIndex = 0
  }

  events() {
    super.events()

    for (let i = 0; i < this.listArray.length; i++) {
      const element = this.listArray[i];

      element.item.addEventListener('mouseover', () => {
        this.zIndex += 1
        element.img.style.zIndex = this.zIndex
        element.img.classList.add('active')
        if (this.oldIndex !== i) {
          gsap.fromTo(element.img, {
            opacity: 0
          }, {
            opacity: 1
          })
        }
        this.oldIndex = i
      })

      element.item.addEventListener('mouseleave', () => {
        element.img.classList.add('inactive')
      })
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/blocks/List.js